import { get, type RequestConfig } from "../shared/api-client";
import type { ApiListResponse } from "@project/types/location";
import type { FeedbackRecord } from "@project/types/feedback";
import { JIVANDHARA_BASE } from "../admin/list-api-helpers";

const SILENT: RequestConfig = { showNotification: false };

class TestimonialService {
  listEnabled = async (): Promise<FeedbackRecord[]> => {
    const response = await get<ApiListResponse<FeedbackRecord>>(
      `${JIVANDHARA_BASE}/feedbacks/`,
      {
        ...SILENT,
        params: { page: 1, page_size: 20, is_enabled: true },
      }
    );

    return (response?.data ?? [])
      .filter(item => item.is_enabled === true)
      .sort((a, b) => (a.order_by ?? 0) - (b.order_by ?? 0));
  };
}

export const testimonialService = new TestimonialService();
